document.addEventListener("DOMContentLoaded", () => {
  const $header = document.querySelector(".js-header");
  if (!$header) return;

  const $stickyContents = document.querySelectorAll(".o-grid__item--sticky");
  const isAdmin = document.body.classList.contains("admin-bar");

  let lastScroll = 0;
  let ticking = false;

  function isMenuOpen() {
    // Le burger mobile pose `.is-open`, le mégamenu desktop pose
    // `.megamenu-is-open` : les deux doivent bloquer la rétractation du
    // header, sinon celui-ci (et le mégamenu qui lui est rattaché) peut se
    // masquer pendant que l'utilisateur scrolle la page pour lire un menu
    // ouvert plus grand que la fenêtre (cas fréquent à fort niveau de zoom).
    return $header.classList.contains("is-open") || $header.classList.contains("megamenu-is-open");
  }

  function onScroll() {
    const scrollY = window.scrollY;
    const scrollingDown = scrollY > lastScroll;

    if (scrollY > 400 && !isMenuOpen()) {
      if (!$header.classList.contains("sticky")) {
        // `has-transition` doit être posée en même temps que `sticky`,
        // sinon un scroll rapide (molette) qui fait franchir le seuil de
        // 400px et déclenche l'ajout de `header-hidden` dans le même appel
        // se voit appliquer `top`/`opacity` sans transition (elle n'était
        // pas encore active) : le header disparaît d'un coup au lieu de
        // glisser hors champ.
        $header.classList.add("sticky", "has-transition");
      }

      if (scrollingDown) {
        $header.classList.add("header-hidden");
        $header.classList.remove("header-visible");
        if (isAdmin) $header.style.top = "0";
        $stickyContents.forEach(el => el.removeAttribute("style"));
      } else {
        $header.classList.remove("header-hidden");
        $header.classList.add("header-visible");
        if (isAdmin) $header.style.top = "50px";
        $stickyContents.forEach(el => (el.style.top = "150px"));
      }

    } else if (scrollY <= 300 && !isMenuOpen()) {
      $header.classList.remove("sticky", "header-hidden", "has-transition");
      if (isAdmin) $header.style.top = "0";
      $stickyContents.forEach(el => el.removeAttribute("style"));
    }

    lastScroll = scrollY;
    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(onScroll);
      ticking = true;
    }
  }

  window.addEventListener("scroll", requestTick);
});
